const fonts = {
  System: "-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
  Sans: "Arial,Helvetica,sans-serif",
  Serif: "Georgia,'Times New Roman',serif",
  Mono: "'Courier New',monospace",
  B612: "'B612',sans-serif",
  Atkinson: "'Atkinson Hyperlegible',sans-serif",
  Andika: "'Andika',sans-serif",
};

// function applyAccessibilityFontSize(fontSize) {
//   const elements = document.querySelectorAll(
//     "h1, h2, h3, h4, h5, h6, p, span, a, label, button, input, select, textarea, option, li, td, th, small",
//   );

//   const scale = fontSize / 16;

//   elements.forEach((element) => {
//     // Store the original font size only once
//     if (!element.dataset.a11yOriginalFontSize) {
//       const originalSize = window.getComputedStyle(element).fontSize;

//       if (originalSize) {
//         element.dataset.a11yOriginalFontSize = originalSize;
//       }
//     }

//     const originalSize = parseFloat(element.dataset.a11yOriginalFontSize);

//     if (!isNaN(originalSize)) {
//       element.style.setProperty(
//         "font-size",
//         `${originalSize * scale}px`,
//         "important",
//       );
//     }
//   });
// }

// function applyAccessibilityFontSize(fontSize) {
//   const elements = document.querySelectorAll(
//     "body h1:not(.a11y-panel *), " +
//       "body h2:not(.a11y-panel *), " +
//       "body h3:not(.a11y-panel *), " +
//       "body h4:not(.a11y-panel *), " +
//       "body h5:not(.a11y-panel *), " +
//       "body h6:not(.a11y-panel *), " +
//       "body p:not(.a11y-panel *), " +
//       "body span:not(.a11y-panel *), " +
//       "body a:not(.a11y-panel *), " +
//       "body label:not(.a11y-panel *), " +
//       "body button:not(.a11y-panel *), " +
//       "body input:not(.a11y-panel *), " +
//       "body select:not(.a11y-panel *), " +
//       "body textarea:not(.a11y-panel *), " +
//       "body option:not(.a11y-panel *), " +
//       "body li:not(.a11y-panel *), " +
//       "body td:not(.a11y-panel *), " +
//       "body th:not(.a11y-panel *), " +
//       "body small:not(.a11y-panel *)",
//   );

//   const scale = fontSize / 16;

//   elements.forEach((element) => {
//     // Store original font size only once
//     if (!element.dataset.a11yOriginalFontSize) {
//       const originalSize = window.getComputedStyle(element).fontSize;

//       if (originalSize) {
//         element.dataset.a11yOriginalFontSize = originalSize;
//       }
//     }

//     const originalSize = parseFloat(element.dataset.a11yOriginalFontSize);

//     if (!isNaN(originalSize)) {
//       element.style.setProperty(
//         "font-size",
//         `${originalSize * scale}px`,
//         "important",
//       );
//     }
//   });
// }

function applyAccessibilityFontSize(fontSize) {
  const scale = fontSize / 16;

  const applySize = () => {
    const elements = document.querySelectorAll(
      "body h1, body h2, body h3, body h4, body h5, body h6, " +
        "body p, body span, body a, body label, body button, " +
        "body input, body select, body textarea, body option, " +
        "body li, body td, body th, body small",
    );

    elements.forEach((element) => {
      // Don't resize accessibility sidebar
      if (element.closest(".a11y-panel")) {
        return;
      }

      // Store original size only once
      if (!element.dataset.a11yOriginalFontSize) {
        const originalSize = window.getComputedStyle(element).fontSize;

        if (originalSize) {
          element.dataset.a11yOriginalFontSize = originalSize;
        }
      }

      const originalSize = parseFloat(element.dataset.a11yOriginalFontSize);

      if (!isNaN(originalSize)) {
        element.style.setProperty(
          "font-size",
          `${originalSize * scale}px`,
          "important",
        );
      }
    });
  };

  // Apply to current page
  applySize();

  // Re-apply when React changes the page
  if (window.__a11yFontObserver) {
    window.__a11yFontObserver.disconnect();
  }

  window.__a11yFontObserver = new MutationObserver(() => {
    applySize();
  });

  window.__a11yFontObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

export default function applyTypography(settings) {
  const html = document.documentElement;

  // Always enable accessibility engine
  html.classList.add("a11y-enabled");

  const selectedFont = settings.text.fontFamily;

  /*
   * DEFAULT
   * -------
   * Remove accessibility font override completely.
   * This allows the original website CSS to control fonts:
   *
   * .font1 -> Bebas Neue
   * .font2 -> Poppins
   * etc.
   */
  if (!selectedFont || selectedFont === "Default") {
    html.classList.remove("a11y-font-override");

    html.style.removeProperty("--a11y-font-family");
  } else {
    /*
     * Accessibility font selected
     */
    html.classList.add("a11y-font-override");

    html.style.setProperty(
      "--a11y-font-family",
      fonts[selectedFont] || "inherit",
    );
  }

  /*
   * Font size
   */
  // const percent = (settings.text.fontSize / 16) * 100;

  // html.style.setProperty("--a11y-font-size", `${percent}%`);

  applyAccessibilityFontSize(settings.text.fontSize);

  // const percent = (settings.text.fontSize / 16) * 100;

  // html.style.setProperty("--a11y-font-size", `${percent}%`);

  /*
   * Letter spacing
   */
  html.style.setProperty(
    "--a11y-letter-spacing",
    `${settings.text.letterSpacing}px`,
  );

  /*
   * Word spacing
   */
  html.style.setProperty(
    "--a11y-word-spacing",
    `${settings.text.wordSpacing}px`,
  );
}
